<div class="cl-device-input" fxFlex *ngIf="deviceInput.isVisible && formControl">
    <dl-text-number-sensor
        *ngIf="!hasMinMax"
        [units]="units"
        [step]="step"
        [deviceInput]="deviceInput"
        [inputFormControl]="formControl"
        [getValidators]="getValidators"
        [invokeCommand]="invokeCommand"
    >
    </dl-text-number-sensor>
    <dl-slider-number-sensor
        *ngIf="hasMinMax"
        [units]="units"
        [step]="step"
        [deviceInput]="deviceInput"
        [inputFormControl]="formControl"
        [getValidators]="getValidators"
        [invokeCommand]="invokeCommand"
        [deviceInputForm]="deviceInputForm"
    >
    </dl-slider-number-sensor>

    <div class="validation-right" [ngClass]="alertClass" *ngIf="formControl && formControl.errors && (formControl.errors.min || formControl.errors.max)">
        ( {{ deviceInput.minValue + "-" + deviceInput.maxValue }} )
    </div>

    <div class="validation-right" [ngClass]="alertClass" *ngIf="formControl && formControl.errors && formControl.errors.ngStep">
        Must be a multiple of {{ ngStep }}
    </div>

    <div class="validation-right" [ngClass]="alertClass" *ngIf="formControl && formControl.errors && formControl.errors.custom && deviceInput.$customValidatorMessage">
        {{ deviceInput.$customValidatorMessage }}
    </div>

</div>
